export const REACT_APP_FIREBASE_DB_PATH_CONFIG = 'v2/configuration'
export const REACT_APP_FIREBASE_DB_PATH_MONITORING = 'v2/monitoring/players'
export const REACT_APP_FIREBASE_DB_PATH_COMMANDS = 'v2/commands/webplayer'
export const REACT_APP_WATCHDOG_ENDPOINT = 'https://watchdog.csdm.cloud:9090/stomp'
export const REACT_APP_WEBCONTAINER_HEARTBEAT_INTERVAL = 10000